import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../../models';
import { SYSTEM_FEATURE_ROOT } from '../../shared-data';

const dpRoot = `${SYSTEM_FEATURE_ROOT}|Exams`;

export type CPExamsDataLocs = 'CPExamsAlteredGradeContent';

export const cpExamsDataLocs: LocDefs<CPExamsDataLocs> = {
	CPExamsAlteredGradeContent: {
		defaultValue: 'Completed',
		displayPath: `${dpRoot}|Exams|Altered Grade`,
		description: `System value for altered grade`,
		displayType: 'Content',
		htmlAllowed: false,
		shared: true,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/System.AlteredGrade',
	},
};

export const examsDataLocs = {
	...cpExamsDataLocs,
};

export type ExamsDataLoc = CPExamsDataLocs;
export type CPExamsDataLocType = LocMap<CPExamsDataLocs>;
export type ExamsDataLocType = LocMap<ExamsDataLoc>;

export const EXAMS_DATA_SYSTEM_LOCS = MapLocKeys<ExamsDataLoc>(examsDataLocs);
